import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import {
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { EtapasBeneficioComponent } from '../../shared/components/etapas-beneficio/etapas-beneficio.component';
import { SessionService } from '../../core/services/session.service';
import { BeneficiaryService } from '../../core/services/beneficiary.service';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { MatProgressBarModule } from '@angular/material/progress-bar';

@Component({
  standalone: true,
  selector: 'app-alteracoes-funcionais',
  templateUrl: './alteracoes-funcionais.component.html',
  styleUrls: ['./alteracoes-funcionais.component.scss'],
  imports: [
    CommonModule,
    MatCardModule,
    MatTableModule,
    MatIconModule,
    MatButtonModule,
    MatDialogModule,
    EtapasBeneficioComponent,
    MatSnackBarModule,
    MatProgressBarModule,
  ],
})
export class AlteracoesFuncionaisComponent implements OnInit {
  alteracoes: any[] = [];
  beneficiario: any = '';

  // estado do upload
  selectedFile: File | null = null;
  uploading = false;
  alteracaoSelecionada: any = null;
  private dialogRef?: MatDialogRef<any>;

  displayedColumns: string[] = [
    'dataInicio',
    'dataFim',
    'cargo',
    'composicao',
    'portaria',
    'diarioOficial',
    'pagina',
    'status',
    'acoes',
  ];

  @ViewChild('modalUpload') modalUpload!: TemplateRef<any>;

  constructor(
    private sessionService: SessionService,
    private beneficiarioService: BeneficiaryService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.beneficiario = this.sessionService.beneficiario;
    this.beneficiarioService
      .getAlteracoesFuncionais(
        this.beneficiario.matricula,
        this.beneficiario.orgao.id
      )
      .subscribe({
        next: (res: any) => {
          this.alteracoes = res;
        },
        error: (err: any) => {
          console.error('Erro ao buscar alterações funcionais', err);
        },
      });
  }

  getDadosBeneficiario() {
    this.beneficiario = this.sessionService.beneficiario;
    this.beneficiarioService
      .getAlteracoesFuncionais(
        this.beneficiario.matricula,
        this.beneficiario.orgao.id
      )
      .subscribe({
        next: (res: any) => {
          this.alteracoes = res;
        },
        error: (err: any) => {
          console.error('Erro ao buscar alterações funcionais', err);
        },
      });
  }

  abrirModalUpload(alteracao: any): void {
    this.alteracaoSelecionada = alteracao; // contem provimentoId
    this.selectedFile = null;
    this.uploading = false;

    this.dialogRef = this.dialog.open(this.modalUpload, {
      data: alteracao,
      width: '600px',
      maxWidth: '95vw',
    });
  }

  remover(id: number): void {
    console.log('Remover', id);
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.selectedFile =
      input.files && input.files.length ? input.files[0] : null;
  }
  baixarRelatorio(): void {
    const { matricula, orgao } = this.beneficiario;

    this.beneficiarioService
      .downloadAlteracoesFuncionaisRelatorio(matricula, orgao.id)
      .subscribe({
        next: (blob: Blob) => {
          // tenta extrair nome de arquivo do header (se a API enviar)
          const filenameFallback = `quadro_alteracoes_funcionais_${matricula}.pdf`;
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = filenameFallback;
          document.body.appendChild(a);
          a.click();
          a.remove();
          window.URL.revokeObjectURL(url);
        },
        error: (err) => {
          console.error('Erro ao baixar relatório:', err);
        },
      });
  }

  enviarDocumento(): void {
    if (!this.selectedFile || !this.alteracaoSelecionada) return;

    this.uploading = true;

    this.beneficiarioService
      .uploadAlteracaoFuncionalDocumento(
        this.alteracaoSelecionada.provimentoId,
        this.selectedFile
      )
      .subscribe({
        next: (res: any) => {
          this.uploading = false;
          if (/^(erro|falha|não foi possível)/i.test(res?.message?.trim() ?? '')) {
            this.snackBar.open(res.message, 'Fechar', {duration: 5000});
            return;
          }
          this.snackBar.open('Documento enviado com sucesso ✅', 'Fechar', {
            duration: 3000,
            horizontalPosition: 'right',
            verticalPosition: 'bottom',
          });
          this.dialogRef?.close();
          this.getDadosBeneficiario();
        },
        error: (err) => {
          this.uploading = false;
          console.error('Erro ao enviar documento', err);
          this.snackBar.open('Falha ao enviar documento ❌', 'Fechar', {
            duration: 4000,
            horizontalPosition: 'right',
            verticalPosition: 'bottom',
          });
        },
      });
  }

  downloadFile(alteracao: any): void {
    if (!alteracao?.hashDoc) {
      this.snackBar.open(
        'Nenhum documento anexado para esta linha.',
        'Fechar',
        {
          duration: 3000,
          horizontalPosition: 'right',
          verticalPosition: 'bottom',
        }
      );
      return;
    }

    this.beneficiarioService
      .downloadDocumentoPorHash(alteracao.hashDoc)
      .subscribe({
        next: (res) => {
          const blob = res.body as Blob;

          // tenta extrair filename do header Content-Disposition
          const cd =
            res.headers.get('Content-Disposition') ||
            res.headers.get('content-disposition') ||
            '';
          const match = /filename\*?=(?:UTF-8''|")?([^\";]+)/i.exec(cd);
          const filenameFromHeader = match
            ? decodeURIComponent(match[1])
            : null;

          const fallback = `alteracao_funcional_${alteracao.provimentoId}.pdf`;
          const filename = filenameFromHeader || fallback;

          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          a.remove();
          window.URL.revokeObjectURL(url);
        },
        error: (err) => {
          console.error('Erro ao baixar documento:', err);
          this.snackBar.open('Falha ao baixar documento.', 'Fechar', {
            duration: 3000,
            horizontalPosition: 'right',
            verticalPosition: 'bottom',
          });
        },
      });
  }

  deletarDocumento(alteracao: any): void {
    if (!alteracao?.hashDoc) {
      this.snackBar.open(
        'Nenhum documento anexado para esta linha.',
        'Fechar',
        {
          duration: 3000,
          horizontalPosition: 'right',
          verticalPosition: 'bottom',
        }
      );
      return;
    }

    // se quiser confirmação, podemos adicionar depois
    this.beneficiarioService
      .deleteDocumentoPorHash(alteracao.hashDoc)
      .subscribe({
        next: () => {
          this.snackBar.open('Documento excluído com sucesso ✅', 'Fechar', {
            duration: 3000,
            horizontalPosition: 'right',
            verticalPosition: 'bottom',
          });
          this.getDadosBeneficiario();
          // atualiza a linha localmente para refletir a remoção
          alteracao.hashDoc = null;
        },
        error: (err) => {
          console.error('Erro ao excluir documento:', err);
          this.snackBar.open('Não foi possível excluir o documento. Tente novamente.', 'Fechar', {
            duration: 3000,
            horizontalPosition: 'right',
            verticalPosition: 'bottom',
          });
          this.getDadosBeneficiario();
        },
      });
  }

  salvarDados(): void {
    this.beneficiarioService.atualizarAlteracoesFuncionais(this.beneficiario.matricula,this.beneficiario.orgao.id).subscribe({
      next:dados=>{this.alteracoes=dados;this.snackBar.open('Dados atualizados.','Fechar',{duration:3000});},
      error:()=>this.snackBar.open('Não foi possível atualizar as alterações funcionais.','Fechar',{duration:5000})
    });
  }
}
